import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { planningChartAPI } from "../../../api/service";
import {  ISchedulerChartData } from "../../../api/planning-charts/planning-chart.model";
import { DocumentDataResponse } from "../../../api/maintenance-order/my-governance.model";
import myGovernanceApi from "../../../api/maintenance-order/my-governance.api";
import { API_RESPONSE_STATUS } from "../../../constants/common.constant";

export interface IAssignDocumentSlice {
  response: any;
  loading: boolean;
  error: any;
  status: string;
}

const INITIAL_STATE = {
  response: null,
  loading: false,
  error: null,
  status: "idle"
} as IAssignDocumentSlice;

export const _assignDocument = createAsyncThunk(
  "myGovernance/assignDocument",
  myGovernanceApi.assignDocumentToWO
);

export const assignDocumentSlice = createSlice({
  name: "assignDocument",
  initialState: INITIAL_STATE,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(_assignDocument.pending, (state) => {
        state.loading = true;
        state.status = API_RESPONSE_STATUS.LOADING;
      })
      .addCase(_assignDocument.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.response = action.payload.data;
        state.status = API_RESPONSE_STATUS.SUCCESS;
      })
      .addCase(_assignDocument.rejected, (state, action) => {
        state.loading = false;
        state.response = null;
        state.error = action.payload;
        state.status = API_RESPONSE_STATUS.FAILED;
      })
  },
});